import { useEffect, useState, } from "react";
import { Modal, Table } from "react-bootstrap";
import { actuacionesService } from "../../../../../_services/actuaciones.service";

export const DatosModal = ({ show, handleClose, etapaId }) => {
  const [datos, setDatos] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res = await actuacionesService.getDatosCargados(etapaId);
      
      setDatos(res);
      setLoading(false);
    };

    getData();
  }, [etapaId]);

  //   {
  //     "id": 141,
  //     "id_etapa": 31997,
  //     "cp8480": 0,
  //     "cpantprv": 0,
  //     "monto": 3174.69,
  //     "nroexpte": "7412",
  //     "caratula": "MUNICIPALIDAD DE SAN NICOLAS C/ TEISSEIRE MARIELA",
  //     "juzgado": "3",
  //     "nrotit": "34682",
  //     "periodos": "2009/1.2.3.4.5.6.7.8.9.10.11.12\r\r2010/1.2.3.4.5.6.7.8.9.10.11.12\r\r2011/1.2.3.4.5.6.7.8.9.10.11.12\r\r2012/1.2.3.4.5.6.7.8.9.10.11.12\r\r2013/1.2.3.4.5.6.7.8.9.10.11.12\r\r2014/1.2.3.4.5.6"
  // }

  return (
    <Modal
      animation={false}
      show={show}
      onHide={handleClose}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Datos cargados en radicación de juicio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loading ? datos ? (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Nro Expediente</th>
                <th>Carátula</th>
                <th>Nro de Título Ejecutivo</th>
                <th>Juzgado que interviene</th>
                <th>Monto</th>
                <th>Cumplimiento con pago de Bono Ley 8480</th>
                <th>Cumplimiento con pago Anticipo Previsional</th>
                <th>Períodos que abarca</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{datos.nroexpte}</td>
                <td>{datos.caratula}</td>
                <td>{datos.nrotit}</td>
                <td>{datos.juzgado}</td>
                <td>{datos.monto}</td>
                <td>{+datos.cp8480 ? "Si" : "No"}</td>
                <td>{+datos.cpantprv ? "Si" : "No"}</td>
                <td>{datos.periodos}</td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <div className="text-center p-4" style={{ color: "gray", fontSize: 20 }}>Sin datos cargados</div>
        )
          : (
            <div className="text-center p-4" style={{ color: "#3085d6", fontSize: 20 }}>Cargando...</div>
          )}
      </Modal.Body>
    </Modal>
  );
};